import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { EnvironmentProvider, TrackingProvider, useEnvironmentVariables, type Environment } from "@workleap-ai/shared";
import { QueryClientDefaultOptions } from "@workleap-ai/shared/http";
import { MixpanelSource } from "@workleap-ai/shared/types";
import type { PropsWithChildren } from "react";
import { IntercomProvider as ReactIntercomProvider } from "react-use-intercom";

export const queryClient = new QueryClient({
    defaultOptions: QueryClientDefaultOptions
});

export const QueryProvider = ({ children }: PropsWithChildren) => {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {process.env.ISOLATED && (
                <ReactQueryDevtools initialIsOpen={false} />
            )}
        </QueryClientProvider>
    );
};

const IntercomProvider = ({ children }: PropsWithChildren) => {
    const { intercomAppId } = useEnvironmentVariables();

    return (
        <ReactIntercomProvider appId={intercomAppId}>
            {children}
        </ReactIntercomProvider>
    );
};

export const Providers = ({ children }: PropsWithChildren) => {
    const environment = process.env.APP_ENV as Environment;

    return (
        <EnvironmentProvider environment={environment}>
            <TrackingProvider trackingAppIdentifier="wai" trackingSource={MixpanelSource.HeroApp}>
                <QueryProvider>
                    <IntercomProvider>
                        {children}
                    </IntercomProvider>
                </QueryProvider>
            </TrackingProvider>
        </EnvironmentProvider>
    );
};
